import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Provider } from "react-redux";
import store from "./store";
// import Login from "./pages/Login";
import Home from "./pages/Home";
import Practice from "./pages/Practice";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { actions } from "./model";
import HomeAdmin from "./pages/HomeAdmin";
import PracticeAdmin from "./pages/PracticeAdmin";
// import AmlPage from "./pages/AML";
// import ForgotPasswordComponent from "./components/Login/ForgotPassword";
import TokenRedirect from "./pages/TokenRedirect";
import { CircularProgress } from "@mui/material";

function ProtectedRoute({ children }) {
  const user = useSelector((state) => state.user?.redux_object || null);

  if (user && user.accessToken) {
    return children;
  }

  // variabile
  window.location.href = process.env.REACT_APP_RETURN_LEXIA_TOOLS;

  return null;
}

function App() {
  const user = useSelector((state) => state.user?.redux_object || null);

  const globalLoading = useSelector((state) => state.ui.globalLoading);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [urlParamsAml, setUrlParamsAml] = useState("");
  const [isToolsDomain, setIsToolsDomain] = useState(false);

  useEffect(() => {
    const currentOrigin = window.location.origin;
    setIsToolsDomain(currentOrigin === "https://aperturapratica.lexia.it");
    // setIsToolsDomain(currentOrigin === "https://stg.aperturapratica.lexia.it/");
  }, []);

  // codice momentaneo per lo switch intervista
  useEffect(() => {
    const currentUrl = window.location.href;

    const match = currentUrl.match(/aml-(.+)/);
    const extractedPart = match ? match[1] : null;

    setUrlParamsAml(extractedPart);
  }, [location]);

  useEffect(() => {
    if (user?.accessToken) {
      if (user.user?.admin === 1) {
        dispatch(actions.getPracticeAdmin());
      } else {
        dispatch(actions.getPractice());
      }
    }
  }, [user?.accessToken, dispatch]);

  useEffect(() => {
    {
      user?.user?.admin === 1
        ? dispatch(actions.getPracticeAdmin())
        : dispatch(actions.getPractice());
    }
  }, [dispatch]);

  return (
    <>
      {globalLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2000,
          }}
        >
          <CircularProgress style={{ color: "#1b2838" }} />
        </div>
      )}

      <Routes>
        <Route path="/token-login" element={<TokenRedirect />} />

        <Route
          path="/"
          element={
            <ProtectedRoute>
              {user?.user?.admin === 1 ? (
                <HomeAdmin isToolsDomain={isToolsDomain} />
              ) : (
                <Home isToolsDomain={isToolsDomain} />
              )}
            </ProtectedRoute>
          }
        />

        {user?.user?.admin !== 1 && (
          <Route
            path="/practice"
            element={
              <ProtectedRoute>
                <Practice />
              </ProtectedRoute>
            }
          />
        )}

        <Route
          path="/practice/:id"
          element={
            <ProtectedRoute>
              {user?.user?.admin === 1 ? <PracticeAdmin /> : <Practice />}
            </ProtectedRoute>
          }
        />

        {/* <Route path="/login" element={<Login />} /> */}
        {/* <Route path="/reset-password" element={<ForgotPasswordComponent />} /> */}

        {/* 404 */}
        <Route path="*" element={<h1>404: Pagina non trovata</h1>} />
      </Routes>
    </>
  );
}

function Root() {
  return (
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>
  );
}

export default Root;
